import { IExplorableItemTypeInfo, INamedItemInfo, IScheduledItemInfo } from '../models/resourceInfoParts';
import { FlowRunError } from '../ServerApi/types/FlowRunError';
import { ISiteNameWithId } from '../ServerApi/types/ISiteNameWithId';
import { ExplorableItemType } from './ContentType';
import { FlowOutputStepInfo } from './FlowOutputStepInfo';

export interface RunFlowTaskInfo extends INamedItemInfo, IScheduledItemInfo, IExplorableItemTypeInfo<'runFlowTask'> {
  flow: INamedItemInfo;
  flowId: string;
  priority: number;
  lastRunAt?: Date;
  runNextAt?: Date;
  site: ISiteNameWithId;
  flowOutputSteps?: FlowOutputStepInfo[];
  runAllOutputs?: boolean;
  suspended?: boolean;
  flowRunErrors?: FlowRunError[];
  status?: RunFlowTaskStatus;
}

export enum RunFlowTaskStatus {
  Suspended = 'SUSPENDED',
  Failed = 'FAILED',
  Succeeded = 'SUCCESS',
  InProgress = 'INPROGRESS',
  Scheduled = 'SCHEDULED'
}
